import React from "react";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import './Timeline.css';

const OrderStatusTimeline = ({ statusLogs }) => {
  const statusColors = {
    Ongoing: "bg-info-subtle text-info", // Blue
    Received: "bg-primary-subtle text-primary", // Purple
    Processing: "bg-warning-subtle text-warning", // Yellow
    Ready: "bg-success-subtle text-success", // Green
    Delivering: "bg-secondary-subtle text-secondary", // Gray
    Cancelled: "bg-danger-subtle text-danger", // Red
    Completed: "bg-success-subtle text-success", // Green
  };

  return (
    <div className="timeline">
      {statusLogs?.map((log, index) => (
        <div key={log.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
          <div className="timeline-line"></div>
          <div className="timeline-icon">
            <span className={`badge ${statusColors[log.currentStatus]}`}>
              {log.currentStatus}
            </span>
          </div>
          <div className="timeline-content">
            <h6 className="mb-1">{formatDateTime(log.createdDate)}</h6>
            <p className="text-muted mb-0">{log.remarks || "No remarks provided."}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderStatusTimeline;